import { Container, Grid } from "@mui/material";
import refundRules from "../../../assets/imgs/refund-rules.png";
import refundRules2 from "../../../assets/imgs/refund-rules2.png";

function RefundRules() {
    return (
        <Container maxWidth="xl">
            <Grid component="img" src={refundRules} container item xs={12} display={{ xs: "none", md: "flex" }} my={5} />
            <Grid component="img" src={refundRules2} container item xs={12} display={{ xs: "flex", md: "none" }} my={5} />
        </Container>
    )
}
export default RefundRules;